import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Table,
    notification,
    Modal,
    Button,
    Image
} from "antd";
import axios from "axios";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { baseUrl } from "../../config";
import { skeletonData } from "../../components/skeletons/Setting";

// table code start
const columns = [
    {
        title: "Page Title",
        dataIndex: "title",
        key: "title"
    },
    {
        title: "Page",
        dataIndex: "page",
        key: "page"
    },
    {
        title: "Content",
        dataIndex: "content",
        key: "content"
    },
    {
        title: "Action",
        key: "action",
        dataIndex: "action",
    }
];

function SettingList() {
    const [loading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [privacy, setPrivacy] = useState('');
    const [titleName, setTitleName] = useState();

    useEffect(() => {
        getList()
    }, [])

    async function getList() {
        try {
            setLoading(true);
            // Make API call to submit form data
            const response = await axios.get(`${baseUrl}/api/page-content`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            });
            if (response.status === 200) {
                setUserList(response.data.result);
            } else {
                setUserList([]);
            }
            // Handle success response from the API
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight' // You can adjust the placement as needed
            });
            // Handle error response from the API
        } finally {
            setLoading(false); // End loading
        }
    };

    const showModal = (privacy, name) => {
        setTitleName(name);
        setPrivacy(privacy || '')
        setModalVisible(true);
    };

    const handleOk = () => {
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Page Management"
                            extra={
                                <>
                                    {userList?.length < 2 &&
                                        <Link className="custom-btn" to="/page-management/add">Add</Link>
                                    }
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={loading ? skeletonData : userList.map((user, index) => ({
                                        index: index + 1,
                                        title: user.title,
                                        page: user.page,
                                        content: (
                                            <Button type="primary" onClick={() => showModal(user.content, 'Content')}>
                                                <EyeOutlined />
                                            </Button>
                                        ),
                                        action: (
                                            <div className="button-container">
                                                <Link to={`/page-management/update/${user._id}`} className="update-btn">
                                                    <EditOutlined />
                                                </Link>
                                            </div>
                                        )
                                    }))}
                                    pagination={false}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal
                title={`${titleName}`}
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <div className="author-info">
                    <div dangerouslySetInnerHTML={{ __html: privacy }} />
                </div>
            </Modal>
        </>
    );
}

export default SettingList;
